<script setup lang="ts">

import { faUserCheck } from '@fortawesome/pro-regular-svg-icons'

import { AppSelectSearchable } from '@shared/ui/selects'
import { BtnIcon } from '@shared/ui/buttons'

import { useTaskResponsibleAssignee } from '../../model/task-responsible-assignee.hook'

defineOptions({
  name: 'TaskResponsibleAssignee',
})

const {
  refAssigneeId,
  refOptions,
  refCanAssignMe,
  assignMe,
} = useTaskResponsibleAssignee()
</script>

<template>
  <div class="task-responsible-assignee">
    <AppSelectSearchable
      v-model="refAssigneeId"
      :options="refOptions"
      placeholder="Select here"
      clearable
    />
    <BtnIcon
      :icon="faUserCheck"
      tooltipText="Assign to me"
      :disabled="!refCanAssignMe"
      @click="assignMe"
    />
  </div>
</template>

<style scoped lang="scss" src="./TaskResponsibleAssignee.scss" />
